import {Button} from '@mantine/core';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {Title} from 'src/design/atoms/Title';

export interface ErrorFallbackProps {
  error: Error;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({error}) => {
  return (
    <Stack mt="md" gap="md">
      <Title order={3}>
        An error occurred. We are working to fix this issue as soon as
        possible.
      </Title>
      <Text c="dimmed">{error.message}</Text>
      <Button
        variant="light"
        w="fit-content"
        onClick={() => window.location.reload()}>
        Reload Page
      </Button>
    </Stack>
  );
};
